export default __webpack_public_path__ + "static/media/FlightOption4.b7534b7c.jpg";